// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_3coQ5","footerInner":"index_footerInner_2Jt9y","logo":"index_logo_2tR9e"};